import OBase from './OBase';

import * as Geometry from '../geometry';

export default class DeconstructPlane extends OBase {
  update () {
    let valTree = this.getPlaneInput('Plane', false);
    let oOutput = this.getGenericObjectOutput('Origin');
    let xOutput = this.getGenericObjectOutput('X-Axis');
    let yOutput = this.getGenericObjectOutput('Y-Axis');
    let zOutput = this.getGenericObjectOutput('Z-Axis');

    var outOTree = new Geometry.DataTree();
    var outXTree = new Geometry.DataTree();
    var outYTree = new Geometry.DataTree();
    var outZTree = new Geometry.DataTree();
    for (let i = 0; i < valTree.branches.length; i++) {
      for (let j = 0; j < valTree.branches[i].length; j++) {
        let plane = valTree.branches[i][j];

        let orig = plane.center;
        let xaxis = plane.xAxis;
        let yaxis = plane.yAxis;
        let zaxis = plane.normal;
        outOTree.add(orig, valTree.paths[i]);
        outXTree.add(xaxis, valTree.paths[i]);
        outYTree.add(yaxis, valTree.paths[i]);
        outZTree.add(zaxis, valTree.paths[i]);
      }
    }

    oOutput.value = outOTree;
    xOutput.value = outXTree;
    yOutput.value = outYTree;
    zOutput.value = outZTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/DeconstructPlane.js